const FINISHED_PATTERNS = [
  /livraison\s+termin/i,
  /livr[ée]e?/i,
  /delivered/i,
];

export function isFinishedTrackStatus(value = '') {
  return FINISHED_PATTERNS.some((pattern) =>
    pattern.test(String(value).trim())
  );
}

function parseLocalDate(value) {
  if (!value) return null;

  const dateValue = String(value).slice(0, 10);
  const [year, month, day] = dateValue.split('-').map(Number);

  if (!year || !month || !day) return null;

  return new Date(year, month - 1, day);
}

export function computedStatus(shipment, now = new Date()) {
  if (shipment.completed_at || shipment.status === 'completed') {
    return {
      key: 'completed',
      label: 'Livraison terminée',
      delayDays: 0,
    };
  }

  if (shipment.status === 'pending_preparation') {
    return {
      key: 'pending_preparation',
      label: 'En attente de préparation',
      delayDays: 0,
    };
  }

  const estimatedDeliveryDate = parseLocalDate(
    shipment.estimated_delivery_date
  );

  if (!estimatedDeliveryDate) {
    return {
      key: 'in_delivery',
      label: 'En cours de livraison',
      delayDays: 0,
    };
  }

  const today = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );

  const delayDays = Math.floor(
    (today.getTime() - estimatedDeliveryDate.getTime()) / 86400000
  );

  if (delayDays >= 1) {
    return {
      key: 'late',
      label: `En retard J+${delayDays}`,
      delayDays,
    };
  }

  return {
    key: 'in_delivery',
    label: 'En cours de livraison',
    delayDays: 0,
  };
}

export function statusRank(shipment) {
  const status = computedStatus(shipment);

  const ranks = {
    late: 0,
    pending_preparation: 1,
    in_delivery: 2,
    completed: 3,
  };

  return ranks[status.key] ?? 99;
}
